import getPathnameLocationUtil from 'utils/location/get-pathname'

export default function isCollectionUrlLocationUtil () {
  return getPathnameLocationUtil().startsWith('/collections')
}
